import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaUserResolver_GetBuckets = UsersTableDefinitionZod.shape.buckets;

export type SchemaUserResolver_GetBuckets = z.infer<typeof schemaUserResolver_GetBuckets>;

export type UserResolver_GetBuckets = Resolver<Arguments, SchemaUserResolver_GetBuckets>;
